import type { AccountPurpose } from '@ema-atr/shared';
import { AlertTriangle, CheckCircle2, CircleDashed, XCircle } from 'lucide-react';

const statusMap = {
  healthy: { label: '正常', className: 'success', icon: CheckCircle2 },
  warning: { label: '需关注', className: 'warning', icon: AlertTriangle },
  offline: { label: '离线', className: 'danger', icon: XCircle },
  unknown: { label: '未同步', className: 'muted', icon: CircleDashed }
} as const;

export function StatusBadge({ status }: { status: keyof typeof statusMap }) {
  const item = statusMap[status];
  const Icon = item.icon;
  return <span className={`status-badge ${item.className}`}><Icon size={14} />{item.label}</span>;
}

export function PurposeBadge({ purpose }: { purpose: AccountPurpose }) {
  return <span className={`purpose-badge ${purpose}`}>{purpose === 'test' ? '真实资金测试' : purpose === 'read_only' ? '只读账户' : '正式账户'}</span>;
}
